export default {
  //url: 'http://localhost/apptletico/backend/public/admin/api/v1/',  
    url: 'https://timeclockapp.eirsmx.com/admin/api/v1/',  
  }